import Box from '@mui/material/Box';

import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import {
    loadOnboardDevicesOnlinePeers,
    selectOnboardDevicesOnlinePeers,
    selectOnboardDevicesOnlinePeersError,
    selectOnboardDevicesOnlinePeersLoading,
} from '../store/devices.reducer';
import { OnboardDevicesOnlineTableGrid } from '../Components/OnboardDevicesOnlineTableGrid';
import { emptyOnboardDevicesOnlinePeers } from '../utils/onboardDevicesOnlineTable';

export const OnboardDevicesOnline = () => {
    const dispatch = useAppDispatch();

    const peersOnline = useAppSelector(selectOnboardDevicesOnlinePeers);
    const peersOnlineLoading = useAppSelector(selectOnboardDevicesOnlinePeersLoading);
    const peersOnlineError = useAppSelector(selectOnboardDevicesOnlinePeersError);

    useEffect(() => {
        dispatch(loadOnboardDevicesOnlinePeers());
    }, [dispatch]);

    return (
        <Box sx={{ width: '100%', padding: '20px', height: '100vh' }}>
            <OnboardDevicesOnlineTableGrid
                peers={peersOnline || emptyOnboardDevicesOnlinePeers}
                loading={peersOnlineLoading}
                error={peersOnlineError}
                onReload={() => dispatch(loadOnboardDevicesOnlinePeers())}
            />
        </Box>
    );
};
